<template>
  <div v-if="currencyOptions.length" id="input-currency-selector" class="items-flex">
    <v-chip-group v-model="myValue" active-class="primary" mandatory column hide-details>
      <v-chip v-for="currency in currencyOptions" :key="currency" :value="currency" small>
        {{ currency }}
      </v-chip>
    </v-chip-group>
    <InfoIcon :size="17" :text="infoText" />
  </div>
</template>

<script>
import InfoIcon from '@/views/components/common/InfoIcon'

export default {
  components: {
    InfoIcon,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    currencyOptions: {
      type: Array,
      default: () => [],
    },
    infoText: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    myValue: null,
  }),
  watch: {
    value: {
      handler() {
        this.myValue = this.value
      },
      immediate: true,
    },
    myValue() {
      this.$emit('input', this.myValue)
    },
  },
}
</script>

<style lang="scss">
#input-currency-selector {
  &.items-flex {
    display: flex;
  }
}
</style>
